import { ChartSpline, Files, List } from 'lucide-react'
import { ReactNode } from 'react'

import { EntityKey, ResultIcon } from '#/components/AdvancedSearch/types'
import { ItemIcon } from '#/components/AdvancedSearch/View/CategoryBadge'
import { AnimalIcon, BatchIcon, CTechIcon, HomeIcon } from '#/components/Icon/Collection'
import { PageCategory } from '#/store/services/Pages/PagesService'
import Colors from '#/styles/Colors'

const ENTITY_ICONS: Record<EntityKey, ReactNode> = {
  animals: <AnimalIcon />,
  batches: <BatchIcon />,
  collars: <CTechIcon />,
  farms: <HomeIcon />,
}

const PAGE_CATEGORY_ICONS: Record<PageCategory, ReactNode> = {
  analytics: <ChartSpline size={18} />,
  lists: <List size={18} />,
  resources: <Files size={18} />,
}

export function EntityCategoryIcon({ collar, entity }: { entity: EntityKey; collar?: number }) {
  let color: keyof typeof Colors.searchFilters = entity

  // Animal sem coleira usa a cor animals_without_collar
  if (entity === 'animals' && collar === undefined) {
    color = 'animals_without_collar'
  }

  return <ItemIcon icon={ENTITY_ICONS[entity]} color={Colors.searchFilters[color]} />
}

export function PageCategoryIcon({ category }: { category: PageCategory }) {
  return <ItemIcon icon={PAGE_CATEGORY_ICONS[category]} color={Colors.searchFilters[category]} />
}

/** Ícone de um resultado de busca, a partir da forma já resolvida em ResultIcon */
export function ResultIconBadge({ icon }: { icon: ResultIcon }) {
  if (icon.source === 'entity') {
    return <EntityCategoryIcon entity={icon.entity} collar={icon.collar} />
  }

  return <PageCategoryIcon category={icon.category} />
}
